<template>
  <ClerkSessionBridge v-if="clerkEnabled" />
  <router-view />
</template>

<script>
import { defineComponent, defineAsyncComponent, onMounted } from 'vue'
import { useComposition } from '@/compositions/composition'
import Cookies from 'js-cookie'
import { clerkEnabled } from '@/auth/config'
import { fetchCurrentUser } from '@/auth/sessionApi'
import ax from 'axios'

export const axios = ax

export default defineComponent({
  components: clerkEnabled
    ? {
        ClerkSessionBridge: defineAsyncComponent(() => import('@/components/ClerkSessionBridge.vue'))
      }
    : {},
  setup() {
    const { global } = useComposition()

    const readLegacyJwt = () => {
      const fromCookie = Cookies.get('authToken')
      if (fromCookie) {
        return fromCookie
      }
      const match = window.location.hash.match(/#token=(.*)/)
      if (match) {
        Cookies.set('authToken', match[1], { expires: 7, secure: true })
        return match[1]
      }
      return null
    }

    const bootstrap = async () => {
      try {
        global.value.jwtToken = readLegacyJwt()
        global.value.user = await fetchCurrentUser()

        const dataResponse = await axios.get(`${process.env.VUE_APP_API_ROOT}/cms-content.json`)
        if (!global.value.navigation) {
          throw new Error('global.value.navigation er undefined')
        }
        global.value.navigation.pages = dataResponse.data.pages || []
        global.value.sponsors = dataResponse.data.sponsors || []
        global.value.cmsContent = dataResponse.data.content || {}
      } catch (error) {
        // user.php returns not-logged-in JSON for guests — still fine
      }
    }

    onMounted(bootstrap)

    return {
      global,
      clerkEnabled
    }
  }
})
</script>

<style lang="scss">
@use "../_scss/main";
</style>
